// SearchBar.js
import React from 'react';
import CommonSearch from '../../components/CommonSearch';

const SearchBar = () => {
  return (
    <CommonSearch
      placeholder="Search Doctors, Hospitals or Specialty"
     sx={{
      '& .MuiInputBase-input::placeholder': {
        fontSize: {xs:'0.6rem',md:'0.8rem',lg:'0.9rem',xl:'0.9rem'},
        padding: 0,
        fontWeight: 600,
      }
     }}
    />
  );
};

export default SearchBar;